const asyncReducer = (state, action, type, mapFulfilledActionToState, config = {}) => {
  switch (action.type) {
    case `${type}_PENDING`:
      return {
        ...state,
        busy: true,
        error: null,
      };
    case `${type}_FULFILLED`:
      return {
        ...state,
        ...mapFulfilledActionToState(state, action),
        busy: false,
        error: null,
        lastFetched: new Date(),
      };
    case `${type}_REJECTED`:
      return {
        ...state,
        busy: false,
        error: action.payload instanceof Error
          ? action.payload.message
          : config.defaultErrorMessage || 'Unexpected error',
      };
    default:
      return undefined;
  }
};

export default asyncReducer;
